import { ListItemButton, styled } from "@mui/material";
import { COLORS } from "../../../constants/colors";

export const StyledListItemButton = styled(ListItemButton)`
  max-height: 2.5em;
  position: relative;
  overflow: hidden;
  padding-left: 22px;
  &.Mui-selected,
  &.Mui-selected:hover {
    background-color: ${COLORS.SURFACE_SELECTED};

    &.active {
      & > .MuiListItemText-root > .MuiTypography-root {
        font-weight: 600;
      }

      & > .MuiListItemIcon-root > i {
        color: ${({ theme }) => theme?.palette?.primary?.main};
      }
    }
  }
`;
